import { render, staticRenderFns } from "./SmsSendList.vue?vue&type=template&id=204765d4&"
import script from "./SmsSendList.vue?vue&type=script&lang=ts&"
export * from "./SmsSendList.vue?vue&type=script&lang=ts&"
import style0 from "./SmsSendList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports